import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 

import tableIcons from '../../utils/editTableIcons';

import style from './awbInfo.module.css';
import commonStyles from '../common/common.module.css';
import moment from 'moment';

const iconFontSize = 20;

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: '#000',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
  });

interface CustomsInfoComponentProps {
  classes: any;
  awbCode?: string;
  awbNumber?: string;
  userId: string;
  timeStamp: string;
};

interface CustomsInfo {
  name: string;
  date: string;
  time: string;
};

const customsInfoComponent = (props: CustomsInfoComponentProps) => {

  const { classes } = props;
  const date = moment(props.timeStamp).format('DD MMM YY');
  const time = moment(props.timeStamp).format('HH:mm');

  const customInfo: Array<CustomsInfo> = [{
    name: props.userId,
    date,
    time
  }]

  return (
    <div className={ `${ commonStyles.wrapper } ${ style.wrapper }` }>
      <h3 className={ `${ commonStyles.header } ${ style.header }` }>Customs Clearance</h3>
      <div className={ style.inputsWrapper } >

        <div>
          <MaterialTable
            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
            icons={ tableIcons }
            data= { customInfo }

            columns={[
              { title: 'Agent ID', field: 'name' },
              { title: 'Date', field: 'date' },
              { title: 'Time', field: 'time' },

            ]}

            options={{
              search: false,
              paging: false,
              showTitle: false,
              actionsColumnIndex: -1,
              toolbar: false,
              sorting: false,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
            }}
          />
        </div>

      </div>

    </div>
  );
};

export default withStyles(styles)(customsInfoComponent);